module.exports = __webpack_public_path__ + "img/middle-boy1.7b613f3f.svg";